/* ============================================================
   TLC THEME JS — header, falling keys, reveals
   ============================================================ */
(function(){
  "use strict";

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- mobile header toggle ---------- */
  document.querySelectorAll("[data-tlc-header]").forEach(function(header){
    var toggle = header.querySelector("[data-tlc-toggle]");
    if(!toggle) return;
    toggle.addEventListener("click", function(){
      var open = header.classList.toggle("tlc-header--open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  /* ---------- falling keys ---------- */
  document.querySelectorAll("[data-tlc-key-field]").forEach(function(field){
    if(reducedMotion) return;
    var src = field.getAttribute("data-key-src");
    if(!src) return;
    var maxKeys = window.innerWidth < 750 ? 3 : 4;
    var live = 0;
    var hero = field.closest(".tlc-hero");

    function spawn(){
      if(live >= maxKeys || document.hidden) return;
      live++;
      var heroH = hero ? hero.offsetHeight : 700;
      var el = document.createElement("div");
      el.className = "tlc-key-fall";
      var size = 52 + Math.random()*86;
      el.style.left = (Math.random()*94)+"%";
      el.style.setProperty("--r0", (Math.random()*50-25)+"deg");
      el.style.setProperty("--r1", (Math.random()*80-40)+"deg");
      el.style.setProperty("--fy", (heroH + 640)+"px");
      el.style.setProperty("--op", String(.5 + Math.random()*.5));
      el.style.animationDuration = (5.5+Math.random()*4.5)+"s";

      var inner = document.createElement("div");
      inner.className = "tlc-key-sway";
      inner.style.setProperty("--sx",(3+Math.random()*8)+"px");
      inner.style.setProperty("--sd",(2.6+Math.random()*2.4)+"s");

      var img = document.createElement("img");
      img.src = src;
      img.alt = "";
      img.loading = "lazy";
      img.style.width = size+"px";
      img.style.height = "auto";

      inner.appendChild(img);
      el.appendChild(inner);
      field.appendChild(el);

      el.addEventListener("animationend", function(){
        el.remove();
        live--;
      });
    }

    for(var i=0;i<maxKeys;i++){
      setTimeout(spawn, i*380 + Math.random()*220);
    }
    setInterval(spawn, 3200);
  });

  /* ---------- scroll reveals ---------- */
  if("IntersectionObserver" in window && !reducedMotion){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add("is-visible");
          io.unobserve(e.target);
        }
      });
    },{threshold:.12,rootMargin:"0px 0px -40px 0px"});
    document.querySelectorAll(".tlc-reveal").forEach(function(el){io.observe(el);});
  } else {
    document.querySelectorAll(".tlc-reveal").forEach(function(el){el.classList.add("is-visible");});
  }
})();

/* ============ supper club door entrance ============ */
(function(){
  "use strict";
  var scene = document.querySelector("[data-tlc-door]");
  if(!scene) return;
  var content = document.querySelector("[data-tlc-door-content]");
  var reveal = function(){ if(content) content.classList.add("is-revealed"); };

  if(window.matchMedia("(prefers-reduced-motion: reduce)").matches){
    reveal();
    return;
  }

  document.body.style.overflow = "hidden";
  var panel = scene.querySelector("[data-tlc-door-panel]");
  var knocker = scene.querySelector("[data-tlc-knocker]");
  var soundOn = scene.getAttribute("data-sound") === "true";
  var finished = false;

  function thud(){
    if(!soundOn) return;
    try{
      var ctx = thud.ctx || (thud.ctx = new (window.AudioContext||window.webkitAudioContext)());
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = "sine"; o.frequency.setValueAtTime(82, ctx.currentTime);
      o.frequency.exponentialRampToValueAtTime(48, ctx.currentTime + .12);
      g.gain.setValueAtTime(.5, ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(.001, ctx.currentTime + .22);
      o.connect(g); g.connect(ctx.destination);
      o.start(); o.stop(ctx.currentTime + .24);
    }catch(e){}
  }

  function knockOnce(){
    if(knocker){ knocker.classList.remove("is-knocking"); void knocker.offsetWidth; knocker.classList.add("is-knocking"); }
    if(panel){ panel.classList.remove("is-knocking"); void panel.offsetWidth; panel.classList.add("is-knocking"); }
    thud();
  }

  function open(){
    if(finished) return; finished = true;
    scene.classList.add("is-opening");
    setTimeout(function(){
      scene.classList.add("is-open");
      document.body.style.overflow = "";
      reveal();
    }, 900);
  }

  var t1 = setTimeout(knockOnce, 700);
  var t2 = setTimeout(knockOnce, 1400);
  var t3 = setTimeout(knockOnce, 2100);
  var t4 = setTimeout(open, 2900);

  var skip = scene.querySelector("[data-tlc-door-skip]");
  if(skip){
    skip.addEventListener("click", function(){
      [t1,t2,t3,t4].forEach(clearTimeout);
      open();
    });
  }
})();

/* ============ supper club archive carousel ============ */
(function(){
  "use strict";
  document.querySelectorAll("[data-tlc-archive-track]").forEach(function(track){
    var section = track.closest(".tlc-archive");
    if(!section) return;
    var step = function(){
      var card = track.querySelector(".tlc-archive-card");
      return card ? card.getBoundingClientRect().width + 32 : 640;
    };
    var prev = section.querySelector("[data-tlc-archive-prev]");
    var next = section.querySelector("[data-tlc-archive-next]");
    if(prev) prev.addEventListener("click", function(){ track.scrollBy({left: -step(), behavior: "smooth"}); });
    if(next) next.addEventListener("click", function(){ track.scrollBy({left: step(), behavior: "smooth"}); });
    track.addEventListener("keydown", function(e){
      if(e.key === "ArrowLeft"){ e.preventDefault(); track.scrollBy({left: -step(), behavior: "smooth"}); }
      if(e.key === "ArrowRight"){ e.preventDefault(); track.scrollBy({left: step(), behavior: "smooth"}); }
    });
  });

  /* image reveal observer (for images outside .tlc-reveal wrappers) */
  if("IntersectionObserver" in window && !window.matchMedia("(prefers-reduced-motion: reduce)").matches){
    var io2 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add("is-visible"); io2.unobserve(e.target); }
      });
    },{threshold:.15});
    document.querySelectorAll(".tlc-img-reveal").forEach(function(el){
      if(!el.closest(".tlc-reveal")) io2.observe(el);
    });
  } else {
    document.querySelectorAll(".tlc-img-reveal").forEach(function(el){ el.classList.add("is-visible"); });
  }
})();

/* ============ manifesto: principle artifacts ============ */
(function(){
  "use strict";
  var wrap = document.querySelector("[data-tlc-principles]");
  if(!wrap) return;
  var artifacts = wrap.querySelectorAll("[data-tlc-artifact]");
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ceremonial one-by-one reveal */
  if("IntersectionObserver" in window && !reduced){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        artifacts.forEach(function(a, i){
          setTimeout(function(){ a.classList.add("is-visible"); }, i * 280);
        });
        io.disconnect();
      });
    },{threshold:.25});
    io.observe(wrap);
  } else {
    artifacts.forEach(function(a){ a.classList.add("is-visible"); });
  }

  /* detail modal */
  var modal = document.querySelector("[data-tlc-artifact-modal]");
  if(!modal) return;
  var mImg = modal.querySelector("[data-tlc-modal-img]");
  var mTitle = modal.querySelector("[data-tlc-modal-title]");
  var mDesc = modal.querySelector("[data-tlc-modal-desc]");
  var lastFocus = null;

  function openModal(a){
    lastFocus = a;
    mTitle.textContent = a.getAttribute("data-title") || "";
    mDesc.textContent = a.getAttribute("data-desc") || "";
    var img = a.getAttribute("data-img");
    mImg.innerHTML = img ? '<img src="'+img+'" alt="" loading="eager">' : a.querySelector(".tlc-artifact__img").innerHTML;
    modal.classList.add("is-open");
    document.body.style.overflow = "hidden";
    modal.querySelector("[data-tlc-artifact-close]").focus();
  }
  function closeModal(){
    modal.classList.remove("is-open");
    document.body.style.overflow = "";
    if(lastFocus) lastFocus.focus();
  }
  artifacts.forEach(function(a){ a.addEventListener("click", function(){ openModal(a); }); });
  modal.querySelector("[data-tlc-artifact-close]").addEventListener("click", closeModal);
  modal.addEventListener("click", function(e){ if(e.target === modal) closeModal(); });
  document.addEventListener("keydown", function(e){ if(e.key === "Escape" && modal.classList.contains("is-open")) closeModal(); });
})();
